import { gql } from '@apollo/client';

export const fireAreaFragments = {
  fireAreaItem: gql`
    fragment FireAreaItem on FireArea {
      id
      name
      engineeringStatus
      revision
      preparedTime
      preparedBy
      checkedTime
      checkedBy
      approvedTime
      approvedBy
      updatedBy
      updatedTime
      fireAreaZones {
        id
        name
        description
      }
      updatedByUser {
        id
        nameFirst
        nameLast
        userAccountPhoto {
          id
          photo
        }
      }
      approvedByUser {
        id
        nameFirst
        nameLast
        userAccountPhoto {
          id
          photo
        }
      }
      checkedByUser {
        id
        nameFirst
        nameLast
        userAccountPhoto {
          id
          photo
        }
      }
      preparedByUser {
        id
        nameFirst
        nameLast
        userAccountPhoto {
          id
          photo
        }
      }
    }
  `,
};

export const CREATE_FIRE_AREA = gql`
  ${fireAreaFragments.fireAreaItem}
  mutation CreateFireArea($createFireAreaInput: CreateFireAreaInput!) {
    createFireArea(createFireAreaInput: $createFireAreaInput) {
      errors
      fireArea {
        ...FireAreaItem
      }
    }
  }
`;

export const UPDATE_FIRE_AREA = gql`
  ${fireAreaFragments.fireAreaItem}
  mutation UpdateFireArea($updateFireAreaInput: UpdateFireAreaInput!) {
    updateFireArea(updateFireAreaInput: $updateFireAreaInput) {
      errors
      fireArea {
        ...FireAreaItem
      }
    }
  }
`;

export const GET_FIRE_AREA_BY_ID = gql`
  ${fireAreaFragments.fireAreaItem}
  query FireAreaById($id: ID!) {
    fireAreaById(id: $id) {
      ...FireAreaItem
    }
  }
`;

export const DELETE_FIRE_AREA = gql`
  mutation DeleteFireArea($deleteFireAreaInput: DeleteFireAreaInput!) {
    deleteFireArea(deleteFireAreaInput: $deleteFireAreaInput) {
      errors
      id
    }
  }
`;

export const GET_FIRE_AREA_BY_IDS = gql`
  ${fireAreaFragments.fireAreaItem}
  query FireAreaByIds($ids: [ID!]!) {
    fireAreaByIds(ids: $ids) {
      ...FireAreaItem
    }
  }
`;

export const ISSUE_FIRE_AREAS = gql`
  ${fireAreaFragments.fireAreaItem}
  mutation IssueFireAreas($issueFireAreasInput: [IssueFireAreaInput!]!) {
    issueFireAreas(issueFireAreasInput: $issueFireAreasInput) {
      fireAreas {
        ...FireAreaItem
      }
      errors {
        messageKeys
      }
    }
  }
`;
